<template>
  <transition name="fade">
    <div class="loading" v-show="status.isLoading">
      <div class="circle">
        <div class="spinner"></div>
        <div class="inner-circle">
          <img
            :src="appUrl + '/img/icons/configure_icon.svg'"
            alt="configure"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";

export default {
  name: "Loading",
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      status: Status.getters.getStatus,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.loading {
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.9;
  flex-grow: 1;
}

.circle {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: #ddd;
  border-radius: 50%;
}

.inner-circle {
  width: 94%;
  height: 94%;
  background: white;
  border-radius: 50%;
  margin: auto;
  vertical-align: middle;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.inner-circle img {
  left: 0.9em;
  top: 0.9em;
  position: relative;
}

.spinner {
  height: 0;
  width: 0;
  border-radius: 50%;
  border-right: 50px solid $brandGold;
  border-top: 50px solid transparent;
  border-left: 50px solid transparent;
  border-bottom: 50px solid transparent;

  animation: rotate 1.5s infinite linear;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
